import "core-js/modules/es6.promise";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../services/apiService';
var DEFAULT_TAG_ITEMS = ['Building', 'Room', 'Door', 'School', 'accessMgmt', 'District'];
export default {
  name: 'CoreTags',
  props: {
    tags: {
      type: Array,
      required: true
    },
    externalTags: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    label: {
      type: String,
      default: '',
      required: false
    },
    tagListType: {
      type: String,
      default: 'digitalTwin',
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    height: {
      type: [String, Number],
      default: 'auto',
      required: false
    }
  },
  data: function data() {
    return {
      search: '',
      internalTags: this.tags,
      tagItems: DEFAULT_TAG_ITEMS
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])),
  watch: {
    tags: {
      handler: function handler(newVal) {
        this.internalTags = newVal;
      }
    }
  },
  mounted: function mounted() {
    this.fetchTagList();
  },
  methods: {
    process: function process() {
      this.search = '';
      var cleanTags = this.internalTags // remove empty and non-string tag items
      .filter(function (tag) {
        return typeof tag === 'string' && tag.trim() !== '';
      }) // trim whitespace from tags
      .map(function (tag) {
        return tag.trim();
      }); // remove any duplicates from tags

      this.internalTags = _toConsumableArray(new Set(cleanTags));
      this.$emit('update:tags', this.internalTags);
    },
    remove: function remove(item) {
      if (this.externalTags.includes(item)) {
        return;
      }

      this.internalTags.splice(this.internalTags.indexOf(item), 1);
      this.internalTags = _toConsumableArray(this.internalTags);
      this.process();
    },
    fetchTagList: function () {
      var _fetchTagList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var apiMethod, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiMethod = this.tagListType === 'digitalTwin' ? ApiService.digitalTwinFetchTagsAndZones : ApiService.virtualDeviceFetchTagsAndZones;
                _context.prev = 1;
                _context.next = 4;
                return apiMethod();

              case 4:
                result = _context.sent;
                this.tagItems = result.tagList || [];

                if (this.externalTags.length > 0) {
                  this.tagItems = this.tagItems.map(function (tag) {
                    return {
                      text: tag,
                      value: tag,
                      disabled: _this.externalTags.includes(tag)
                    };
                  });
                }

                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                console.error(_context.t0);
                this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.fetchTagsError'), 'error');

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9]]);
      }));

      function fetchTagList() {
        return _fetchTagList.apply(this, arguments);
      }

      return fetchTagList;
    }(),
    restrictCharacters: function restrictCharacters(event) {
      if (event.key === ',' || event.key === ';') {
        event.preventDefault();
      }
    }
  }
};